/**
 * Created by hernanherreros on 2019-04-30
 */

import * as React from 'react'

interface Catalog {
  [lang: string]: any;
}

export interface LocaleContextInterface {
  currentLanguage: string;
  setLanguage: (language: string) => void;
}

const LocaleContext = React.createContext<LocaleContextInterface | null>(null)

export default LocaleContext
